import { Accordion, AccordionItem, type AccordionProps } from '@tunein/react-ui';
import type { ReactNode } from 'react';

const COLLAPSIBLE_ITEM_VALUE = 'collapsible-content';

export interface CollapsibleProps
  extends Omit<
    AccordionProps,
    'value' | 'defaultValue' | 'onValueChange' | 'multiple' | 'hideTrigger'
  > {
  children: ReactNode;
  isOpen: boolean;
}

export function Collapsible({ children, isOpen, ...props }: CollapsibleProps) {
  return (
    <Accordion
      hideTrigger
      multiple={false}
      value={isOpen ? [COLLAPSIBLE_ITEM_VALUE] : []}
      {...props}
    >
      <AccordionItem name={COLLAPSIBLE_ITEM_VALUE}>{children}</AccordionItem>
    </Accordion>
  );
}
